import React from "react";
import intl from "react-intl-universal";
import { Box, Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";

import { routing } from "routing";

import { Breadcrumbs } from "components/Breadcrumbs";

const { Urls } = routing;

export const BCHome = () => {
  const history = useHistory();

  const breadcrumbs = [
    {
      label: intl.get("SCHEDULE_LABEL"),
    },
  ];

  const handleClick = () => {
    history.push(Urls.CREATE_MATCH());
  };

  return (
    <Box display="flex">
      <Box flexGrow={1}>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </Box>
      <Box mb={4}>
        <Button variant="contained" color="secondary" onClick={handleClick}>
          {intl.get("CALENDAR_CREATE_MATCH")}
        </Button>
      </Box>
    </Box>
  );
};
